//* Libraries imports
import { BaseApiService } from "@services/baseApiService";

//* Types imports
import type {
  ISaleInputDTO,
  ISaleOutputDTO,
  ISaleFilters,
  ValidateSaleTokenInput,
} from "@/schemas/sales";
import { ApiResponse, ApiError } from "@/types/api";

//* Services imports
import { api } from "@/services/api";

class SalesService extends BaseApiService<ISaleOutputDTO> {
  constructor() {
    super("sales");
  }

  async fetchAll(
    filters: ISaleFilters = {},
  ): Promise<ApiResponse<ISaleOutputDTO[]> | ApiError> {
    return await super.fetchAll(filters as any);
  }

  async create(
    data: ISaleInputDTO | Partial<ISaleOutputDTO>,
  ): Promise<ApiResponse<ISaleOutputDTO> | ApiError> {
    return await super.create(data as any);
  }

  async update(
    id: string,
    data: Partial<ISaleInputDTO> | Partial<ISaleOutputDTO>,
  ): Promise<ApiResponse<ISaleOutputDTO> | ApiError> {
    return await super.update(id, data as any);
  }

  async generateToken(
    id: string,
    phone?: string,
  ): Promise<ApiResponse<ISaleOutputDTO> | ApiError> {
    return await api.request<ISaleOutputDTO>(`${this.baseUrl}/${id}/token`, {
      method: "POST",
      body: JSON.stringify({ phone }),
    });
  }

  async validateToken(
    data: ValidateSaleTokenInput,
  ): Promise<ApiResponse<ISaleOutputDTO> | ApiError> {
    return await api.request<ISaleOutputDTO>(`${this.baseUrl}/validate-token`, {
      method: "POST",
      body: JSON.stringify(data),
    });
  }
}

export const salesService = new SalesService();
